// A1 - Final Sınavı
// Kapsamlı final sınavı - Tüm A1 konuları (Ünite sınavlarından FARKLI sorular)

export const A1_FINAL = {
  'A1-FINAL': {
    id: 'A1-FINAL',
    title: 'A1 Final Sınavı',
    type: 'exam',
    exercises: [
      // Present Simple - Olumlu (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'The crew _____ passengers before takeoff.',
        options: ['welcome', 'welcomes', 'welcomed', 'welcoming'],
        correct: 'welcomes',
        explanation: 'The crew (tekil) ile fiil + s eklenir'
      },
      {
        type: 'multipleChoice',
        question: 'Flight attendants _____ safety demonstrations.',
        options: ['perform', 'performs', 'performing', 'performed'],
        correct: 'perform',
        explanation: 'Flight attendants (çoğul) ile fiil kök haliyle'
      },
      // Present Simple - Olumsuz ve Soru (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: "The pilot _____ leave the cockpit during flight.",
        options: ["don't", "doesn't", 'not', "isn't"],
        correct: "doesn't",
        explanation: "The pilot (tekil) ile doesn't kullanılır"
      },
      {
        type: 'multipleChoice',
        question: '_____ this flight go to London?',
        options: ['Do', 'Does', 'Are', 'Is'],
        correct: 'Does',
        explanation: 'Flight (tekil) ile Does kullanılır'
      },
      {
        type: 'multipleChoice',
        question: '_____ long is the flight to Dubai?',
        options: ['What', 'When', 'Why', 'How'],
        correct: 'How',
        explanation: 'Süre sorulduğunda How long kullanılır'
      },
      // There is/are (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'There _____ a bathroom at the back of the plane.',
        options: ['is', 'are', 'be', 'am'],
        correct: 'is',
        explanation: 'A bathroom (tekil) için is'
      },
      {
        type: 'multipleChoice',
        question: '_____ there enough meals for everyone?',
        options: ['Is', 'Are', 'Do', 'Does'],
        correct: 'Are',
        explanation: 'Meals (çoğul) için Are there'
      },
      // Can/Could (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'The captain _____ make announcements.',
        options: ['can', 'cans', 'is can', 'do can'],
        correct: 'can',
        explanation: 'Yetenek için can kullanılır'
      },
      {
        type: 'multipleChoice',
        question: '_____ you help me with my luggage, please?',
        options: ['Could', 'Can', 'Do', 'Are'],
        correct: 'Could',
        explanation: 'Nazik istek için Could tercih edilir'
      },
      {
        type: 'multipleChoice',
        question: "Passengers _____ use phones during takeoff.",
        options: ["can't", 'can', "couldn't", 'could'],
        correct: "can't",
        explanation: 'Yasak için can\'t kullanılır'
      },
      // Imperatives (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: '_____ your tray table for landing.',
        options: ['Fold', 'You fold', 'Folds', 'Folding'],
        correct: 'Fold',
        explanation: 'Emir cümlesi fiil ile başlar'
      },
      {
        type: 'multipleChoice',
        question: '_____ leave your seat during turbulence.',
        options: ["Don't", 'Not', "Doesn't", 'No'],
        correct: "Don't",
        explanation: "Olumsuz emir Don't ile başlar"
      },
      // Fill in the blank
      {
        type: 'fillInBlank',
        sentence: 'The plane _____ (depart) at 10 AM every day.',
        answer: 'departs',
        hint: 'The plane (tekil) ile fiil + s'
      },
      {
        type: 'fillInBlank',
        sentence: "They _____ (not/allow) smoking on board.",
        answer: "don't allow",
        hint: "They ile don't + fiil"
      },
      {
        type: 'fillInBlank',
        sentence: 'There _____ two pilots in the cockpit.',
        answer: 'are',
        hint: 'Two pilots (çoğul)'
      },
      // Matching
      {
        type: 'matchPairs',
        instruction: 'Havacılık terimlerini Türkçeleriyle eşleştirin',
        pairs: [
          { left: 'boarding pass', right: 'biniş kartı' },
          { left: 'cabin crew', right: 'kabin ekibi' },
          { left: 'emergency exit', right: 'acil çıkış' },
          { left: 'seat belt', right: 'emniyet kemeri' }
        ]
      },
      {
        type: 'matchPairs',
        instruction: 'Cümleleri tamamlayın',
        pairs: [
          { left: 'I always', right: 'arrive on time.' },
          { left: 'She never', right: 'forgets the safety check.' },
          { left: 'They usually', right: 'serve meals after takeoff.' },
          { left: 'We sometimes', right: 'have delays.' }
        ]
      }
    ]
  }
};

export default A1_FINAL;
